import showToaster from "../../../../helpers/toasterMessages/showToaster";

export const spreadSheetExportHelper = ({ rowData, languageCode, appType, isRestrict }) => {
    if (isRestrict) {
        showToaster({ messageId: 'demoWarning', toasterType: 'warning' })
        return;
    }
    const escapeCsvCell = (cell) => {
        const str = String(cell ?? '');
        if (/[,"\n\r]/.test(str)) {
            return '"' + str.replace(/"/g, '""') + '"';
        }
        return str;
    };

    const header = 'key,value';
    const rows = (rowData || []).map((row) => {
        const key = row?.[0]?.value != null ? String(row[0].value).trim() : '';
        const value = row?.[1]?.value != null ? String(row[1].value) : '';
        return `${escapeCsvCell(key)},${escapeCsvCell(value)}`;
    });
    const csv = [header, ...rows].join('\r\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    const prefix = appType === 'web' ? 'web-language' : 'mobile-language';
    a.download = `${prefix}-${languageCode || 'export'}.csv`;
    a.click();
    URL.revokeObjectURL(url);
}